export default class CountItem {
  public title: string = '';
  public subTitle: string = '';
  public icon: string = '';
  public iconClass: string = '';
  public value: number = 0;
  public color: string = 'primary';
}
